var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { selectAllExistingBuildingInfo } from "../../selectors/selectExistingBuildingInfo";
import { utilBuildings } from "../../utils/utilBuildings";
import { bugsnagClient } from "../bugsnag/bugsnagClient";
import { ErrorBoundary } from "../generic/ErrorBoundary";
import { List } from "../generic/list/List";
import { actionBuildingsPreSelect } from "../player-base/buildings/actionBuildings";
import { TypeBuildingAction } from "../player-base/buildings/reducerBuildings";
import { ViewportWorldSpace } from "../viewport/ViewportWorldSpace";
import { CalloutBuilding } from "./CalloutBuilding";
var CalloutsDOM = /** @class */ (function (_super) {
    __extends(CalloutsDOM, _super);
    function CalloutsDOM() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.renderCallouts = function (viewport) {
            var buildings = _this.props.buildings;
            var sortedBuildingForCallouts = utilBuildings
                .sortBuildingsPreCalloutRender(buildings, viewport)
                .filter(function (building) { return utilBuildings.isUnderConstruction(building); });
            if (sortedBuildingForCallouts.length === 0) {
                // tslint:disable-next-line:no-null-keyword
                return null;
            }
            return (React.createElement(React.Fragment, null,
                React.createElement(List, { items: sortedBuildingForCallouts, renderItem: _this.createRenderBuildingCallout(viewport) })));
        };
        _this.createRenderBuildingCallout = function (viewport) { return function (building) {
            var onBuildingCalloutClick = _this.props.onBuildingCalloutClick;
            var position = utilBuildings.getHoverPositionOnScreen(building, viewport);
            var style = _this.getStyle(position);
            var key = building.proto.id;
            var onClick = function () { return onBuildingCalloutClick(building, position); };
            return (React.createElement("div", { style: style, key: key, className: "callout", onClick: onClick },
                React.createElement(CalloutBuilding, { building: building })));
        }; };
        _this.getStyle = function (_a) {
            var x = _a.x, y = _a.y;
            return ({
                left: x + "px",
                position: "absolute",
                top: y + "px",
            });
        };
        return _this;
    }
    CalloutsDOM.prototype.render = function () {
        var _this = this;
        var shouldRender = this.props.shouldRender;
        if (!shouldRender) {
            return React.createElement(React.Fragment, null);
        }
        return (React.createElement(ErrorBoundary, { client: bugsnagClient.bugsnag, name: "Callouts.tsx" },
            React.createElement(ViewportWorldSpace, null, function (viewport) { return _this.renderCallouts(viewport); })));
    };
    return CalloutsDOM;
}(React.PureComponent));
var mapState = function (state) {
    var buildingAction = state.playerBase.buildings.action;
    var buildings = selectAllExistingBuildingInfo(state);
    var shouldRender = buildingAction === TypeBuildingAction.None &&
        (buildings || []).some(function (building) { return utilBuildings.isUnderConstruction(building); });
    return {
        buildings: buildings,
        shouldRender: shouldRender,
    };
};
var mapDispatch = function (dispatch) {
    return bindActionCreators({
        onBuildingCalloutClick: actionBuildingsPreSelect,
    }, dispatch);
};
export var Callouts = connect(mapState, mapDispatch)(CalloutsDOM);



//////////////////
// WEBPACK FOOTER
// ./src/features/callouts/Callouts.tsx
// module id = 2234
// module chunks = 3